import React, { Component } from "react";
import Select from "react-select";
import { SkyLightStateless } from 'react-skylight';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import _ from 'lodash';
import {
  Grid,
  Row,
  Col,
  Panel,
  Button,
  Tabs,
  Tab,
  ButtonToolbar,
  Breadcrumb,
  Dropdown,
  MenuItem,
  Input,
} from "react-bootstrap";
import { Translate } from "react-redux-i18n";
import { Toolbar, Data } from "react-data-grid-addons";
import ReactDataGrid from "react-data-grid";
import axios from 'axios';

import {
  ROOT_URL, ROOT_API_URL, isLMH, isSDR
} from '../../../../actions/root_url';

const modalStyle = {
  width: '500px',
  height: '450px',
  marginLeft: '-10%',
}

const propTypes = {
}

const defaultProps = {
}

const styles = {
  promotionContainer: {
    width: '100%',
    height: '300px',
    // border: '1px solid red',
    padding: '20px'
    // overflow: 'auto',
  },
  promotionItem: {
    width: '100%',
    display: 'block',
  },
  buttonToolbar: {
    display: 'flex',
    justifyContent: 'space-evenly',
  }
}

class ApplyPromotions extends Component {
  renderPromotionItem = (promotion) => {
    let description = promotion.Description.slice(0, 15);
    if (promotion.Description.length > 14) {
      description += '...';
    }
    return <li>
      {promotion.DiscountDescription} - {description}
    </li>
  }
  render() {
    const promotions = _.filter(this.props.appliablePromotions, promotion => promotion.Method === "ByQuantity");
    return (
      <div>
        <div style={styles.promotionContainer}>
          <ol>
            {_.map(promotions, promotion => {
              return this.renderPromotionItem(promotion)
            })}
          </ol>
        </div>
        <div style={styles.buttonToolbar}>
          <Button
            bsStyle="primary"
            className="print-btn"
            type="button"
            onClick={() => {
              this.props.applyAndSave();
            }}
          >
            <Translate value="apply" />
          </Button>
          <Button
            bsStyle="primary"
            className="print-btn"
            type="button"
            onClick={() => {
              this.props.notApplyAndSave();
            }}
          >
            {/* <em className="fa fa-pencil" /> */}
            <Translate value="cancel" />
          </Button>
        </div>
      </div>
    )
  }
}

const ApplyPromotionsModal2 = ({ isVisible, setModalVisibility, appliablePromotions, applyAndSave, notApplyAndSave }) => (
  <SkyLightStateless
    title={'Promotion Found'}
    onCloseClicked={setModalVisibility}
    dialogStyles={modalStyle}
    isVisible={isVisible}
  >
    <ApplyPromotions appliablePromotions={appliablePromotions} applyAndSave={applyAndSave} notApplyAndSave={notApplyAndSave} />
  </SkyLightStateless>
)

ApplyPromotionsModal2.propTypes = propTypes
ApplyPromotionsModal2.defaultProps = defaultProps

export default ApplyPromotionsModal2;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/salesOrder/ApplyPromotionsModal2.jsx